document.addEventListener("DOMContentLoaded", () => {
  const productWrappers = document.querySelectorAll(".product-section__details-wrapper[data-product-id]");

  productWrappers.forEach(wrapper => {
    const productId = wrapper.dataset.productId;
    if (!productId) return;

    const variantsEl = document.getElementById(`ProductVariants-${productId}`);
    if (!variantsEl) return;

    let variants;
    try {
      
      variants = JSON.parse(variantsEl.textContent);
     
     const vardata = variants.map(v => {
        return [
            v.id,
            v.available,
            v.title
        ]
      }) 

      console.log( vardata);
      
    } catch (e) {
      console.error("Failed to parse variants JSON", e);
      return;
    }

    const atcButton = wrapper.querySelector(".product-add-to-cart");
    const priceEl = wrapper.querySelector(".product-price span");

    // zillionera fix for variant URL START
    const updateVariantUrl = (variantId) => {
      const url = new URL(window.location.href);
      if (variantId) {
        url.searchParams.set('variant', variantId);
      } else {
        url.searchParams.delete('variant');
      }
      if (url.href !== window.location.href) {
        history.replaceState({}, '', url.toString());
      }
    };
  
    // zillionera fix for variant URL END

     const updateVariantState = () => {
      const selectedOptions = [];
      wrapper.querySelectorAll("input[name^='option-']:checked, select[name^='option-']").forEach(input => {
         const index = parseInt(input.name.replace("option-", ""), 10);
           selectedOptions[index] = input.value;
      });
      

      // Find exact match
      // dev7implement - Default Title product stock status fix
      let matchedVariant;

      const isDefaultTitleProduct =
        variants.length === 1 &&
        variants[0].title === "Default Title" &&
        variants[0].option1 === "Default Title";

      if (isDefaultTitleProduct) {
        matchedVariant = variants[0];
      } else {
        matchedVariant = variants.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
      }

      // Fallback to first available variant
      // if (!matchedVariant) {
      //   matchedVariant = variants.find(v => v.available);
      // }

      if (!matchedVariant) {
          updateVariantUrl(null);

          atcButton.disabled = true;
          atcButton.textContent = "Out of Stock";
          atcButton.setAttribute("aria-disabled", "true");

          const stockText = wrapper.querySelector(".el-delivery-notice .stock-text");
          const stockLabel = wrapper.querySelector(".el-delivery-notice .stock-label");
          const iconInner = wrapper.querySelector(".el-delivery-notice .delivery-notice__pulse-icon .pulse-icon__inner");
          const iconOuter = wrapper.querySelector(".el-delivery-notice .delivery-notice__pulse-icon .pulse-icon__outer");

          if (stockText) stockText.textContent = "Out of Stock";
          if (stockLabel) stockLabel.style.display = "none";

          if (iconInner && iconOuter) {
            iconInner.setAttribute("fill", "#ff0000");
            iconOuter.setAttribute("fill", "#ff0000");
          }

          return;
        }


      
    // zillionera fix for variant URL START

      if (matchedVariant?.id) {
        updateVariantUrl(matchedVariant.id);
      } else {
        updateVariantUrl(null);
      }

    // zillionera fix for variant URL END


      // Update price
      if (priceEl && matchedVariant) {
        priceEl.textContent = "£" + (matchedVariant.price / 100).toFixed(2);
      }

      // Update Add-to-Cart button
      if (!matchedVariant || !matchedVariant.available) {
        atcButton.disabled = true;
        atcButton.textContent = "Out of Stock";
        atcButton.setAttribute("aria-disabled", "true");
      } else {
        atcButton.disabled = false;
        atcButton.textContent = "Add to Cart";
        atcButton.setAttribute("aria-disabled", "false");
      }

      const stockText = wrapper.querySelector(".el-delivery-notice .stock-text");
      const stockLabel = wrapper.querySelector(".el-delivery-notice .stock-label");
      const iconInner = wrapper.querySelector(".el-delivery-notice .delivery-notice__pulse-icon .pulse-icon__inner");
      const iconOuter = wrapper.querySelector(".el-delivery-notice .delivery-notice__pulse-icon .pulse-icon__outer");

      if (!matchedVariant.available) {
        stockText.textContent = "Out of Stock";
        stockLabel.style.display = "none";

        if (iconInner && iconOuter) {
          iconInner.setAttribute("fill", "#ff0000");
          iconOuter.setAttribute("fill", "#ff0000");
        }

      } else {
        stockText.textContent = "In Stock";
        stockLabel.style.display = "inline";

        if (iconInner && iconOuter) {
          iconInner.setAttribute("fill", "#5CD33F");
          iconOuter.setAttribute("fill", "#5CD33F");
        }
      }
    };



    // Initial update
    updateVariantState();

    // Update on option change
    wrapper.querySelectorAll("input[name^='option-'], select[name^='option-']").forEach(input => {
      input.addEventListener("change", updateVariantState);
    });
  });
});

// Add to Cart click handler
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".product-add-to-cart");
  if (!btn) return;

  const productId = btn.dataset.productId;
  if (!productId) return console.error("Product ID not found");

  const variantsEl = document.getElementById(`ProductVariants-${productId}`);
  if (!variantsEl) return console.error("Variants JSON not found for product", productId);

  let variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) {
    console.error("Failed to parse variants JSON", e);
    return;
  }

  // Get selected options
  const selectedOptions = [];
  const wrapper = btn.closest(".product-section__details-wrapper[data-product-id]");
  wrapper.querySelectorAll(`input[name^="option-"]:checked, select[name^="option-"]`).forEach(input => {
      // dev7 fix odring
      const index = parseInt(input.name.replace("option-", ""), 10);
       selectedOptions[index] = input.value;
  });


  console.log("selected options : "+ selectedOptions);
  

  // Find matching variant
  let matchedVariant;

  const isDefaultTitleProduct =
    variants.length === 1 &&
    variants[0].title === "Default Title" &&
    variants[0].option1 === "Default Title";

  if (isDefaultTitleProduct) {
    matchedVariant = variants[0];
  } else {
    matchedVariant = variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  console.log(matchedVariant);

  // Fallback to first available variant
  // if (!matchedVariant) {
  //   matchedVariant = variants.find(v => v.available);
  // }

  if (!matchedVariant || !matchedVariant.available) {
    alert("This product is unavailable.");
    return;
  }

  btn.disabled = true;
  const defaultText = btn.textContent;
  btn.textContent = "Adding…";

  try {
    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: matchedVariant.id, quantity: 1 }] })
    });
    const addData = await addResponse.json();
    if (!addResponse.ok) throw new Error(addData.description || addData.message || "Could not add to cart.");


    // Refresh cart
    const cart = await fetch("/cart.js").then(res => res.json());
    document.dispatchEvent(new CustomEvent("cart:update", {
      bubbles: true,
      detail: { data: { itemCount: cart.item_count, source: "custom-add-to-cart" } }
    }));

    // Open cart drawer if exists
    const cartDrawer = document.querySelector("cart-drawer-component");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }

    btn.textContent = "Added!";
  } catch (err) {
      console.error(err);
    
    // User-friendly error message
    const errorMsg = err.message || "Something went wrong.";
    btn.textContent = "Error";

    // Wrapper ke andar error div dhundo ya banao
    const existingError = wrapper.querySelector(".product-cart-error");
    if (existingError) {
      existingError.textContent = errorMsg;
      existingError.style.display = "block";
    } else {
      const errorDiv = document.createElement("div");
      errorDiv.className = "product-cart-error";
      errorDiv.textContent = errorMsg;
      btn.insertAdjacentElement("afterend", errorDiv);
    }

    // 3 second baad error hide karo
    setTimeout(() => {
      const errEl = wrapper.querySelector(".product-cart-error");
      if (errEl) errEl.style.display = "none";
    }, 3000);
}

  setTimeout(() => {
    btn.textContent = defaultText;
    btn.disabled = false;
  }, 1500);
});